import {observer} from 'mobx-react-lite'
import React, {useEffect, useLayoutEffect, useRef, useState} from 'react'
import tw from 'tailwind-styled-components'
import {backgroundImages} from '@client/background-images'
import {SharedBoardsClient} from '@client/shared-boards-client'
import {FilePreview} from '@common/file-preview'
import {boardSettingsStore} from '@components/board/board-settings/board-settings-store'
import {BoardTabBg} from '@components/board/board-tab-bg'
import {useForceUpdate, useSyncEventUpdateEffect} from '@containers/hooks'
import {globals} from '@extensions/globals-base'

const TwBackgroundContainer = tw.div`
  absolute
  h-full
  w-full
  min-h-full
  min-w-full
`

const TwBackground = tw.div`
  absolute
  h-full
  w-full
  bg-no-repeat
  bg-cover
  bg-left-top
  bg-transparent

`
const TwPreviewBackground = tw(TwBackground)`
  -z-10
`
const TwPrevBackground = tw(TwBackground)`
  -z-100
`

const getSkin = () => {
  if (SharedBoardsClient.isGuest()) {
    return SharedBoardsClient.settings.background || backgroundImages[8]
  }

  return BoardTabBg.getSkin()
}

const getPreview = (skin: string) => {
  const preview = FilePreview.previewFromUrl(skin)
  const previewImage = BoardTabBg.getBackgroundImage(preview)
  return previewImage
}

export const Background = observer(() => {
  const [img] = useState(() => new Image())

  const forceUpdate = useForceUpdate()
  const userId = globals.currentUserId

  const skin = getSkin()
  const previewImage = getPreview(skin)
  const [prevImage, setPrevImage] = useState(() => '')
  const [currImage, setCurrImage] = useState(() =>
    BoardTabBg.getBackgroundImage(skin)
  )

  const skinRef = useRef(skin)
  useEffect(() => {
    skinRef.current = skin
  }, [skin])

  useEffect(() => {
    img.src = BoardTabBg.getSkinUrl(skin)
    img.onload = () => {
      if (skin !== skinRef.current) {
        return
      }

      const newImage = BoardTabBg.getBackgroundImage(skin)
      setPrevImage(currImage || newImage)
      setCurrImage(newImage)
    }

    return () => {
      img.src = '' // abort image loading if it's not already loaded
    }
  }, [img, skin, currImage, skinRef, setCurrImage, setPrevImage])

  useSyncEventUpdateEffect('profile', {filter: userId, debounceTime: 50})

  useLayoutEffect(() => {
    setCurrImage('')
  }, [skin])

  useLayoutEffect(() => {
    forceUpdate()
  }, [boardSettingsStore.state.bgTabModified, forceUpdate])

  // Display previous bg to prevent bg blinking during loading when changed
  return (
    <TwBackgroundContainer>
      <TwPrevBackground style={{backgroundImage: prevImage}} />
      <TwPreviewBackground style={{backgroundImage: previewImage}} />
      <TwBackground style={{backgroundImage: currImage}} />
    </TwBackgroundContainer>
  )
})

// const getShortSkin = (url: string) => {
//   const [, name = ''] = url.split('/user-data/')

//   return name.split('-')[0] || ''
// }
